<template>
  <div class="root">
    <mx-element type="Nav" :theme="Theme" ref="nav"></mx-element>
    <div class="box panel3">
      <div class='flex-row bold'>
        实时概况
      </div>
      <mx-page type="Home" :config="PageConfig" :name="config.Title + '顶部统计'" theme="Panel"></mx-page>

    </div>

  </div>
</template>
<script>
export default {
  props: {
    value: Object,
    config: Object
  },
  data() {
    return { height: 60, }
  },
  computed: {
    Month() {
      return new Date().getMonth() + 1
    },
    PageConfig() {
      return {
        Role: this.config.Role,
        RoleField: this.config.RoleField
      }
    },
    Now() {
      return this.$matrix.formatDateTime(new Date()).replaceAll("/", "-")
    },

    Theme() {
      if (this.config && this.config.Theme) return this.config.Theme
      return 'top'
    },
  },
  mounted() {
    if (this.$refs.nav) {
      this.height = this.$refs.nav.$el.clientHeight + 10
    } else {
      this.height = 0
    }
  },
  created() {
    let user = this.$matrix.GetUser()
    if (!user) this.$matrix.GotoLogin()
  }
}
</script>
<style scoped>
.root {
  display: block;

  overflow-x: hidden;
  position: relative;
  background-color: #f7f7f7;
  /* border-top-left-radius: 20px;
  padding: 20px; */
}

.data-panel {
  margin: 20px 0;
}

.box-con {
  margin: 40px 0;
}

.box {
  padding: 20px;
  margin:10px;
  border-radius: 10px;
}
</style>





